module.exports = __webpack_public_path__ + "img/logo-feelgoodplus-tagline-swedish.0fcce6c9.png";